<template>
  <div class="container">
    <van-nav-bar left-arrow @click-left="$router.back()" title="意见反馈"></van-nav-bar>
    <div class="item">
      <p class="tit">简介</p>
      <van-field
        ref="text"
        v-model="intro"
        type="textarea"
        autosize
        :maxlength="100"
        show-word-limit
        placeholder="请描述呢的问题"
      />
      <van-uploader v-model="images" multiple :max-count="6" />
      <p class="tip">最多6张，单个图片不超过20M。</p>
    </div>
    <div class="item">
      <p class="tit">联系方式</p>
      <van-field
        ref="text"
        v-model="mobile"
        placeholder="请输入手机号码便于联系（非必填）"
      />
    </div>
    <div class="btn">
      <a href="javascript:;">提交反馈</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserFeedback',
  data () {
    return {
      intro: '',
      images: [],
      mobile: ''
    }
  }
}
</script>
<style scoped lang="less">
.container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.item {
  padding: 0 16px;
  /deep/ .van-field {
    background: #F7F8FA;
    padding: 5px 10px;
    border-radius: 4px;
    .van-field__body {
      padding: 5px;
    }
    .van-field__word-limit {
      color: #ccc;
    }
  }
  .van-uploader {
    margin-top: 10px;
    /deep/ .van-uploader__upload {
      border-radius: 4px;
    }
  }
  .tit {
    font-size: 16px;
    line-height: 50px;
  }
  .tip {
    color: #ccc;
  }
}
.btn {
  position: absolute;
  left: 0;
  bottom: 50px;
  width: 100%;
  padding: 16px;
  a {
    color: #fff;
    height: 44px;
    display: block;
    background: linear-gradient(to right,#FE4F4F,#FC6627);
    border-radius: 4px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
  }
}
</style>
